export default __webpack_public_path__ + "static/media/secure.8fb96c80.svg";